import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AOS from 'aos';
import 'aos/dist/aos.css';
import { slide as Menu } from 'react-burger-menu'


import '../assets/css/style.css';
import '../assets/css/custom.css';
import Logo from "../assets/img/logo.png";
import Photo from "../assets/img/profile-img.jpg";

function Header() {
  const navigate = useNavigate();
  const [user, setUser] = useState([]);
  const [menu, setMenu] = useState(false);
  useEffect(() => {
    AOS.init();
  }, [])

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };


  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
  }, []);

  return (

    <>
      <header id="header" className="header fixed-top d-flex align-items-center">
        <div className="d-flex align-items-center justify-content-between">
          <a href="/" className="logo d-flex align-items-center">
            <img src={Logo} alt="" />
            <span className="">Xtrava</span>
          </a>
        </div>
        <nav className="header-nav ms-auto">
          <ul className="d-flex align-items-center desktop-nav">
            <li className="nav-item"><a className="nav-link active" href="/">Home</a></li>
            {/* <li className="nav-item"><a className="nav-link" href="/">Services</a></li>
            <li className="nav-item"><a className="nav-link" href="/">Virtual Cards</a></li> */}
            <li className="nav-item"><a className="nav-link" href="/about">About Us</a></li>
            <li className="nav-item"><a className="nav-link" href="/contact">Contact Us</a></li>
            {/* <li className="nav-item"><a className="nav-link" href="/login">Sign In</a></li> */}
          </ul>
          <i className="bi bi-list toggle-sidebar-btn p-4 d-lg-none d-lg-block" onClick={() => setMenu(true)} />
          <Menu isOpen={menu} width={260} right>
            <li className="nav-item"><a className="nav-link active" href="/">Home</a></li>
            {/* <li className="nav-item"><a className="nav-link" href="/">Services</a></li>
            <li className="nav-item"><a className="nav-link" href="/">Virtual Cards</a></li> */}
            <li className="nav-item"><a className="nav-link" href="/about">About Us</a></li>
            <li className="nav-item"><a className="nav-link" href="/contact">Contact Us</a></li>
            {/* <li className="nav-item"><a className="nav-link" href="/login">Sign In</a></li> */}
          </Menu>
        </nav>
      </header>
    </>
  );
}

export default Header;